import { createLazyFileRoute } from "@tanstack/react-router";

import { ReportPreviewPage } from "@/features/accession/routes/AccessionReport";

export const Route = createLazyFileRoute("/_auth/_app/accessions_/$id/report")({
  component: ReportPreviewPage,
});
